import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PanelProps {
    title?: string
    subtitle?: string
    action?: ReactNode
    children: ReactNode
    className?: string
}

/** Surface used for every block inside a dashboard preview. */
export const Panel: FC<PanelProps> = ({
    title,
    subtitle,
    action,
    children,
    className
}): ReactNode => {
    return (
        <div
            className={cn(
                'min-w-0 rounded-2xl border border-burgundy/[0.08] bg-ivory p-4 shadow-[inset_0_1px_0_rgb(255_255_255/0.8)] sm:p-5',
                className
            )}
        >
            {(title || action) && (
                <div className='mb-4 flex items-start justify-between gap-3'>
                    <div className='min-w-0'>
                        {title && <p className='text-[13px] font-medium text-burgundy'>{title}</p>}
                        {subtitle && <p className='mt-0.5 text-[11px] text-stone'>{subtitle}</p>}
                    </div>

                    {action}
                </div>
            )}

            {children}
        </div>
    )
}
